import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { useManagementCreateOrder } from '@apps-common/apis/management/order'
import { QUERY_SEARCH_ORDERS } from '@apps-common/apis/portal/orders'
import { QUERY_SEARCH_ORDERS_COUNT } from '@apps-common/apis/portal/orders/search-orders-count'
import { QUERY_SEARCH_ORDERS_INFINITE } from '@apps-common/apis/portal/orders/search-orders-infinite'
import {
  ManagementOrderDetailsForm,
  ManagementOrderlineForm,
  ManagementOrderSummaryForm
} from '@apps-common/apps/portal/pages/orders/pages/create/components/management'
import { VertSpacerLg } from '@apps-common/components/layout'
import { CreateOrderSteps } from '@apps-common/config/orders'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { queryClient } from '@apps-common/lib'
import { INewOrderModel } from '@apps-common/types/management/order'

export type StepDirection = 'forward' | 'backward'

// interface IProps {
//   orderId: string
// }

export const ManagementOrderCreateView: React.FC = () => {
  const [step, setStep] = useState<CreateOrderSteps>(CreateOrderSteps.details)
  const { navigateBack } = useNavigation()
  const { mutate: createOrder, isPending: orderIsCreating } = useManagementCreateOrder(true, () => {
    queryClient.refetchQueries({ queryKey: QUERY_SEARCH_ORDERS_COUNT() })
    queryClient.refetchQueries({ queryKey: QUERY_SEARCH_ORDERS() })
    queryClient.refetchQueries({ queryKey: QUERY_SEARCH_ORDERS_INFINITE() })
    navigateBack()
  })
  // const [actionItemUnits, setActionItemUnits] = useState<IUnitSimActiveModel[]>([])

  const methods = useForm<INewOrderModel>({
    mode: 'onChange',
    reValidateMode: 'onChange'
  })
  const { handleSubmit, formState } = methods
  const { isSubmitting } = formState

  const moveStep = (direction: StepDirection) => {
    if (direction === 'forward') {
      if (step === CreateOrderSteps.details) {
        setStep(CreateOrderSteps.orderline)
      } else if (step === CreateOrderSteps.orderline) {
        setStep(CreateOrderSteps.summary)
      }
    } else if (direction === 'backward') {
      if (step === CreateOrderSteps.summary) {
        setStep(CreateOrderSteps.orderline)
      } else if (step === CreateOrderSteps.orderline) {
        setStep(CreateOrderSteps.details)
      }
    }
  }

  // const getActionItem = (unitId: string | null) => actionItemUnits.find((u) => u.unitId === unitId)

  // const updateActionItemUnits = (unit: IUnitSimActiveModel, ids: string[]) => {
  //   let updated = [...actionItemUnits]

  //   if (!updated.find((u) => u.unitId === unit.unitId)) {
  //     updated.push(unit)
  //   }

  //   updated = updated.filter((u) => ids.some((id) => id === u.unitId))

  //   setActionItemUnits(updated)
  // }

  const onSubmit = (values: INewOrderModel) => {
    if (step !== CreateOrderSteps.summary) {
      moveStep('forward')

      return
    }

    createOrder({ model: values })
  }

  const isLoading = false
  const isUpdating = orderIsCreating || isSubmitting

  return (
    <div className='max-w-[900px]'>
      <FormProvider {...methods}>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <ManagementOrderDetailsForm isLoading={isLoading} isUpdating={isUpdating} step={step} move={moveStep} />
          <VertSpacerLg />
          <ManagementOrderlineForm isLoading={isLoading} isUpdating={isUpdating} step={step} move={moveStep} />
          <VertSpacerLg />
          <ManagementOrderSummaryForm isLoading={isLoading} isUpdating={isUpdating} step={step} move={moveStep} />
          <VertSpacerLg />
        </form>
      </FormProvider>
    </div>
  )
}
